import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=30fc608b&scoped=true&"
import script from "./contact-info.vue?vue&type=script&lang=js&"
export * from "./contact-info.vue?vue&type=script&lang=js&"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=30fc608b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fc608b",
  null
  
)

export default component.exports